import React, { useState } from "react";
import Banner from "../Components/Banner";
import Comics from "../Components/Comics";
import Hero from "../Components/Hero";
// import CheckoutButton from "../Components/CheckoutButton";

const Homepage = () => {

  return (
    <main>
      <Hero/>
      {/* <Banner /> */}
      <Comics />
      {/* <CheckoutButton amount={'5.99'}/> */}
    </main>
  );
};

export default Homepage;



// import src1 from "../Assests/images/src1.png";
// import src2 from "../Assests/images/src2.png";
// import src3 from "../Assests/images/src3.png";
// import src4 from "../Assests/images/src4.png";
// import src5 from "../Assests/images/src5.png";
// import src6 from "../Assests/images/src6.png";
// import src7 from "../Assests/images/src7.png";
// import src9 from "../Assests/images/src9.png";
